import { NgTemplateOutlet } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    ContentChild,
    EventEmitter,
    Input,
    Output,
    TemplateRef
} from '@angular/core';
import { ShIconComponent } from '../../elements/components/icon/icon.component';
import { IconSize } from '../../elements/components/icon/icon.module';

@Component({
    selector: 'sh-detail-list-layout',
    templateUrl: './detail-list-layout.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgTemplateOutlet, ShIconComponent]
})
export class DetailListLayoutComponent {
    @Input() detailsCollapsed = true;
    @Input() filtersCollapsed = false;

    @Output() toggleFilters: EventEmitter<boolean> = new EventEmitter<boolean>();

    @ContentChild('topContent') topContent: TemplateRef<any>;
    @ContentChild('detailContent') detailContent: TemplateRef<any>;
    @ContentChild('mainContent') mainContent: TemplateRef<any>;
    @ContentChild('filtersContent') filtersContent: TemplateRef<any>;
    @ContentChild('filtersCollapsedContent') filtersCollapsedContent: TemplateRef<any>;

    public IconSize: typeof IconSize = IconSize;

    public onToggleFilters(e: MouseEvent): void {
        this.toggleFilters.emit(!this.filtersCollapsed);
    }
}
